export default {
  subheadline: 'Setup your notification services',
};
